import React from 'react';
import styled from 'styled-components';
import { measureRollingControlLookup } from '../../utils/builder/rollingControl';
import { RollingControlFunction } from '../../utils/apollo/graphqlSchema';
import { RollingDisplaySize } from './types';

interface IRollingDisplayConfig {
  signSize: number;
  valueSize: number;
}

const rollingDisplayConfig: Record<
  RollingControlFunction,
  Record<RollingDisplaySize, IRollingDisplayConfig>
> = {
  [RollingControlFunction.Avg]: {
    sm: {
      signSize: 14,
      valueSize: 10,
    },
    lg: {
      signSize: 24,
      valueSize: 18,
    },
  },
  [RollingControlFunction.Sum]: {
    sm: {
      signSize: 12,
      valueSize: 10,
    },
    lg: {
      signSize: 22,
      valueSize: 18,
    },
  },
  [RollingControlFunction.Window]: {
    sm: {
      signSize: 12,
      valueSize: 10,
    },
    lg: {
      signSize: 22,
      valueSize: 18,
    },
  },
};

const Container = styled.div<{ $fontSize: number; $isSum?: boolean }>`
  font-size: ${({ $fontSize }) => $fontSize}px;
  font-weight: 600;
  line-height: 1.17;
  color: inherit;
  // rolling control sum display has a specific font-family
  ${({ $isSum }) =>
    $isSum &&
    `
      font-family: Helvetica;
  `}
`;

const Value = styled.span<{ $fontSize: number }>`
  font-size: ${({ $fontSize }) => $fontSize}px;
`;

interface IProps {
  rollingFunction: RollingControlFunction;
  value: string | number;
  displaySize?: RollingDisplaySize;
}

export default ({ rollingFunction, value, displaySize = 'sm' }: IProps) => {
  const sign = measureRollingControlLookup[rollingFunction].sign;

  const { signSize, valueSize } =
    rollingDisplayConfig[rollingFunction][displaySize];

  return (
    <Container
      $fontSize={signSize}
      $isSum={rollingFunction === RollingControlFunction.Sum}
    >
      {sign}
      <Value $fontSize={valueSize}>{value}</Value>
    </Container>
  );
};
